export default __webpack_public_path__ + "static/media/user-plans.9d161c6d.svg";